<div *ngIf="loading" class="loading">
    <mat-spinner  mode="indeterminate"></mat-spinner>
</div>
<div class="students-dismissal-tracking-log-container">
    <div class="students-dismissal-tracking-log-container-header" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
        <svg (click)="back()" xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 6.576 11.257" [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
            <g id="next_1_" data-name="next (1)" transform="translate(6.022 10.703) rotate(180)">
                <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
                    <path id="Path_5603" data-name="Path 5603"
                        d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                        transform="translate(-102.297 0)" fill="#707070" stroke="#707070" stroke-width="1" />
                </g>
            </g>
        </svg>
        <span *ngIf="logType=='not_requested'"  class="students-dismissal-tracking-log-container-header-label">{{'student-dismissal-track.not-requested'| translate}}</span>
        <span *ngIf="logType=='pending'"  class="students-dismissal-tracking-log-container-header-label">{{'student-dismissal-track.getting-ready'| translate}}</span>
        <span *ngIf="logType=='with_staff'"  class="students-dismissal-tracking-log-container-header-label">{{'student-dismissal-track.student-staff'| translate}}</span>
        <span *ngIf="logType=='all_delivered'"  class="students-dismissal-tracking-log-container-header-label">{{'student-dismissal-track.delivered'| translate}}</span>
        <span *ngIf="logType=='canceled'"  class="students-dismissal-tracking-log-container-header-label">{{'student-dismissal-track.canceled'| translate}}</span> 

    </div>

    <div class="tab-content" id="report-card">
        <app-reports-control-bar [controlType]="controlType" [statusType]="logType" (exportExcel)="exportToExcelFile()" (generateExcel)="generateExcelFile()"></app-reports-control-bar>
        <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)">
        </app-table-view>
    </div>
</div>
<app-view-student></app-view-student>
<app-error-msg></app-error-msg>

